import React from "react";
import classes from "./Services.module.css";

const Pelvic = () => {
  return (
    <div className={classes.Intro}>
      {/**
       * The Header
       */}
      <h1 className={classes.focusLine}>
        <span>PELVIC FLOOR</span>
      </h1>
      {/**
       * The Header
       */}
      <div className={classes.container1}>
        <p>
        Pelvic health physiotherapy is the assessment and treatment of various conditions that involve the pelvic floor or symptoms that manifest in this area. The pelvic floor includes muscles, ligaments, nerves and connective tissue. It plays an important role in the body by providing support for the bladder, genitals, uterus and anus.
        </p>
        {/**
         * The Header
         */}
        <h4>Pelvic Health Physiotherapist provides highly specialized treatment plans for the following women’s health dysfunctions</h4>
        <ul>
          <li>Tightness and weakness of the pelvic floor muscles</li>
          <li>Pelvic girdle pain (PGP), symphysis pubis (SPD) and sacroiliac dysfunction (SIJ)</li>
          <li>Coccydynia (coccyx, tailbone pain)</li>
          <li>Back, neck and rib pain</li>
          <li>Perineal tearing, episiotomy and C-section scar management</li>
          <li>Pelvic organ prolapse</li>
          <li>Urinary incontinence</li>
          <li>Bowel dysfunctions, including incontinence and constipation</li>
          <li>Diastasis recti (otherwise known as tummy gap or mummy tummy)</li>
          <li>Chronic pelvic pain</li>
          <li>Painful intercourse (dyspareunia)</li>
          <li>Vaginal pain from vaginismus and vulvodynia</li>
          <li>Endometriosis</li>
        </ul>
        {/**
         * The Header
         */}
        <h4>Symptoms Associated with Pelvic Floor Dysfunction</h4>
        <ul>
          <li>Pelvic Girdle Pain</li>
          <li>Diastasis Recti</li>
          <li>Hip Pain</li>
          <li>Endometriosis</li>
          <li>Pre & Post Natal Care</li>
          <li>Constipation</li>
          <li>Chronic Low Back Pain</li>
          <li>Chronic Sacroiliac Pain</li>
        </ul>
        <p>
        Pelvic floor dysfunction can be caused by pregnancy and childbirth, hormonal changes like menopause, excessive heavy lifting, pelvic surgery or straining when urinating or having a bowel movement.
        </p>
        <h4>
        What to Expect During Treatment
        </h4>
        <ul>
         <li>Internal Assessment: This involves the insertion of a gloved, lubricated finger into the vagina to evaluate the strength and tension of the pelvic floor muscles. The therapist will thoroughly explain what the assessment and treatment will involve (including proper draping), give you alternative options, and obtain your consent before proceeding. You may withdraw your consent at any time.</li>
         <li>External Assessment: The therapist may also examine the pelvic area externally to assess posture, muscle tone, and alignment.</li>
         <li>Pelvic Floor Exercises: Therapists prescribe targeted exercises to strengthen or relax the pelvic floor muscles based on the patient’s specific condition.</li>
         <li>Biofeedback: This technique involves using sensors to provide visual or auditory feedback about muscle activity during exercises, helping patients understand and control their pelvic floor muscles better.</li>
         <li>Education: Patients receive guidance on proper posture, body mechanics, and behavioural modifications that can support pelvic floor health.</li>
        </ul>
      </div>
    </div>
  );
};

export default Pelvic;
